import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { MarketConfigService } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";

/**
 * @deprecated [fabric-deprecated] - use fabric BlogService from app-site instead
 */
@Injectable({
	providedIn: "root",
})
export class BlogConfigService {
	constructor(
		private service: ConfigService<ObgConfigFeAdaptiveClientCommon>,
		private marketService: MarketConfigService
	) {}

	/**
	 * @deprecated [fabric-deprecated] - use fabric BlogService from app-site instead
	 */
	getFeedUrl(): string {
		return this.service.get((x) => x.common.blog.endpoints!.feed, "v1/content/blog-posts");
	}

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(SiteAppCommand.GetBlogEnabled)" instead
	 */
	getBlogEnabled(): boolean {
		return (
			this.service.get((x) => x.common.blog.isEnabled, false) &&
			this.service
				.get((x) => x.common.blog.supportedMarkets, ["sv", "fi", "no"])
				.includes(this.marketService.getLanguageCode())
		);
	}
}
